import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ['virtualForm', 'locationForm', 'virtualContainer', 'locationContainer'];

  displayVirtualForm() {
    if (this.virtualFormTarget.classList.contains('hidden')) {
      this.locationFormTarget.classList.add('hidden');
      this.virtualFormTarget.classList.remove('hidden');
      this.virtualContainerTarget.classList.replace('border-slate-400', 'border-purple-600');
      this.locationContainerTarget.classList.replace('border-purple-600', 'border-slate-400');
    }
  }

  displayLocationForm() {
    if (this.locationFormTarget.classList.contains('hidden')) {
      this.locationFormTarget.classList.remove('hidden');
      this.virtualFormTarget.classList.add('hidden');
      this.locationContainerTarget.classList.replace('border-slate-400', 'border-purple-600');
      this.virtualContainerTarget.classList.replace('border-purple-600', 'border-slate-400');
    }
  }
}
